import http from 'hub-http/clients/apiClient';
const CONTENT_ASSISTANCE_SETTINGS_URL = 'content-assistance/v1/settings';
const BRAND_VOICE_URL = 'branding/v1/brand-voice';
export const fetchContentAssistanceSettings = () => {
  return http.get(CONTENT_ASSISTANCE_SETTINGS_URL);
};
export const fetchBrandVoiceSettings = (brandKitId = 'primary') => {
  return http.get(`${BRAND_VOICE_URL}/${brandKitId}`);
};